import React from "react";
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaPython, FaWordpress, FaDatabase } from "react-icons/fa";
import { Link } from "react-router-dom";

const technologies = [
  { name: "HTML5", icon: <FaHtml5 className="text-orange-500 text-3xl" /> },
  { name: "CSS3", icon: <FaCss3Alt className="text-blue-500 text-3xl" /> },
  { name: "JavaScript", icon: <FaJs className="text-yellow-500 text-3xl" /> },
  { name: "React", icon: <FaReact className="text-blue-400 text-3xl" /> },
  { name: "Node.js", icon: <FaNodeJs className="text-green-500 text-3xl" /> },
  { name: "Python", icon: <FaPython className="text-blue-600 text-3xl" /> },
  { name: "WordPress", icon: <FaWordpress className="text-indigo-500 text-3xl" /> },
  { name: "Databases", icon: <FaDatabase className="text-gray-600 text-3xl" /> },
];

export default function ForexWebDesign() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      {/* Header Section */}
      <div className="text-center max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-sky-400 mb-4">Forex Web Design</h1>
        <p className="text-lg text-gray-700">
          Elevate Your Forex Brokerage with Our Dynamic and Perfect Web Designs
        </p>
      </div>

      {/* Introduction */}
      <div className="max-w-5xl mx-auto text-center mt-8 px-4">
        <p className="text-gray-600 text-lg">
          At <span className="font-bold text-sky-400">Infyst</span>, we specialize in creating stunning and functional web designs specifically for Forex brokers like you. Our team of expert designers and developers craft dynamic and perfect web designs that capture the essence of your brand and resonate with your target audience.
        </p>
      </div>

      {/* Technologies Section */}
      <div className="max-w-6xl mx-auto mt-12">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">Technical Expertise</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 text-center">
          {technologies.map((tech, index) => (
            <div key={index} className="flex flex-col items-center bg-white p-6 shadow-md rounded-lg hover:shadow-lg transition-all">
              {tech.icon}
              <p className="mt-2 font-medium text-gray-700">{tech.name}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Custom Web Design Solutions */}
      <div className="max-w-6xl mx-auto mt-16 bg-white shadow-lg rounded-xl p-10">
        <h2 className="text-3xl font-bold text-gray-800 text-center">Customized Forex Web Design Solutions</h2>
        <ul className="mt-6 space-y-4 text-gray-600 text-lg">
          <li>✅ <span className="font-semibold">Responsive Design:</span> Ensure a seamless user experience across desktop, tablet, and mobile devices.</li>
          <li>✅ <span className="font-semibold">Customizable Templates:</span> Personalize your website with our customizable templates.</li>
          <li>✅ <span className="font-semibold">User-Friendly Interface:</span> Easy navigation and intuitive design for a superior user experience.</li>
          <li>✅ <span className="font-semibold">Search Engine Optimization (SEO):</span> Optimize your website for search engines to improve visibility and drive organic traffic.</li>
        </ul>
      </div>

      {/* Benefits Section */}
      <div className="max-w-6xl mx-auto mt-16 bg-white shadow-lg rounded-xl p-10">
        <h2 className="text-3xl font-bold text-gray-800 text-center">Benefits of Our Forex Web Design Solutions</h2>
        <ul className="mt-6 space-y-4 text-gray-600 text-lg">
          <li>🚀 <span className="font-semibold">Enhance Your Brand:</span> Establish a strong online presence and reinforce your brand identity.</li>
          <li>🎯 <span className="font-semibold">Increase Conversions:</span> Drive traffic, generate leads, and boost conversions with our optimized web designs.</li>
          <li>💡 <span className="font-semibold">Improve User Experience:</span> Provide a seamless and intuitive user experience that delights your customers.</li>
          <li>📈 <span className="font-semibold">Stay Ahead of the Competition:</span> Differentiate your brokerage business with our unique and customized web designs.</li>
        </ul>
      </div>

      {/* Call to Action */}
      <div className="text-center space-y-3 mt-12">
        <h2 className="text-3xl text-sky-400 font-bold ">Get Started Today!</h2>
        <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
          Discover how our Forex web design solutions can elevate your brokerage business. Contact us to learn more, schedule a consultation, or get a quote.
        </p>
        <div className="flex flex-col gap-4 items-center justify-center">
        
          <Link onClick={() => {
            window.scroll(0, 0)
          }} to="/contact" className="block text-center lg:text-left mt-2 lg:mt-0">
            <button className="bg-sky-500 text-white font-bold px-10 py-3 rounded w-full lg:w-auto">
             Contact-Us
            </button>
          </Link>
          


        </div>
      </div>
    </div>
  );
}
